/* eslint no-console: 0 */


/**
 * Used to create the values used to determine brand specific skinning
 * @param  {iComponents={}} components An object array of components
 * @param  {iColor={}} colors An object array of colour definitions (to be extened to more)
 * @returns iSkin Returns a skin
 */
function skinner(components = {}, colors = {}) {
  return Object.entries(components).reduce((component, [key, entry]) => {
    if (typeof entry === 'object') {
      // recurse if we found an object
      return Object.assign(component, {
        [key]: skinner(entry, colors),
      });
    }

    const value = colors[entry] || entry;

    // Skins are to be used for colours and definitions (also colours)
    if (typeof value === 'undefined' || value === null) {
      console.warn(`Skin entry "${entry}" has no corresponding definition or is not defined`);
    }

    return Object.assign(component, {
      [key]: value,
    });
  }, {});
}

export default skinner;
